import { StyleSheet, Dimensions } from 'react-native'

const styles = StyleSheet.create({
    container: {
        borderRadius: 8,
        overflow: 'hidden',
        backgroundColor: '#f5f5f5',
    },
    item: {
        width: Dimensions.get('window').width - 32,
        paddingVertical: 60,
        backgroundColor: '#007AFF',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 8,
        marginHorizontal: 16,
    },
    button: {
        color: 'white',
        fontSize: 16,
        fontWeight: '600',
    },
})

export default styles
